import { Api } from 'laravel-request';
import { NotifyManager } from 'notify-component';

export default class LoaderWithJob {
  static jobLoadingFlags = {};
  static jobResults = {};

  static handleJob(instance, controller, method, jobKey, activeData, callback) {
    if (!instance.jobIntervalId) {
      const jobIdKey = this.getJobKey(jobKey, activeData.client_id, 'id');
      const jobDateKey = this.getJobKey(jobKey, activeData.client_id, 'date');
      const loadingFlagKey = this.getLoadingFlagKey(
        controller,
        method,
        jobKey,
        activeData.client_id
      );

      activeData.job_id = localStorage.getItem(jobIdKey);
      activeData.job_date = localStorage.getItem(jobDateKey);

      const processData = (response) => this.processData(instance, response, callback);

      const fetchData = () => {
        activeData.job_id = localStorage.getItem(jobIdKey);
        activeData.job_date = localStorage.getItem(jobDateKey);

        this.fetchData(controller, method, activeData, loadingFlagKey, processData);
      };

      if (activeData.job_id) {
        instance.jobIntervalId = setInterval(fetchData, 5000);
        instance.handleJobInterval(instance.jobIntervalId);
        fetchData(); // Call immediately to avoid initial 5s delay
      } else if (!this.jobLoadingFlags[loadingFlagKey]) {
        this.jobLoadingFlags[loadingFlagKey] = false;
        Api.get(controller, method, activeData).call((response) => {
          this.initiateJobFetching(
            instance,
            response,
            jobIdKey,
            jobDateKey,
            loadingFlagKey,
            fetchData,
            processData
          );
        });
      } else {
        instance.jobIntervalId = setInterval(() => {
          if (this.jobLoadingFlags[loadingFlagKey]) {
            processData(this.jobResults[loadingFlagKey]);
          }
        }, 5000);
        instance.handleJobInterval(instance.jobIntervalId);
      }
    }
  }

  static getJobKey(jobKey, clientId, type) {
    return `${jobKey}_${type}.${clientId}`;
  }

  static getLoadingFlagKey(controller, method, jobKey, clientId) {
    return `${controller}_${method}_${jobKey}_${clientId}`;
  }

  static fetchData(controller, method, activeData, loadingFlagKey, processData) {
    if (!this.jobLoadingFlags[loadingFlagKey]) {
      this.jobLoadingFlags[loadingFlagKey] = true;
      Api.get(controller, method, activeData)
        .withoutNotify()
        .call(
          (response) => {
            this.updateLoadingFlag(loadingFlagKey, response);
            // Only process data if the job is complete and contains the expected payload
            if (response.result === 'success' && response.data && !response.data.job_id) {
              processData(response);
            }
          },
          (error) => {
            this.jobLoadingFlags[loadingFlagKey] = false;
          }
        );
    }
  }

  static processData(instance, response, callback) {
    instance.setState(
      {
        ...instance.prepareData(response),
        loading: false,
      },
      () => {
        this.clearJobInterval(instance);
        callback();
      }
    );
  }

  static initiateJobFetching(
    instance,
    response,
    jobIdKey,
    jobDateKey,
    loadingFlagKey,
    fetchData,
    processData
  ) {
    if (response.data.job_id && response.data.job_date) {
      localStorage.setItem(jobIdKey, response.data.job_id);
      localStorage.setItem(jobDateKey, response.data.job_date);
      instance.jobIntervalId = setInterval(fetchData, 5000);
      instance.handleJobInterval(instance.jobIntervalId);
      fetchData(); // Call immediately to avoid initial 5s delay
    } else if (response.result === 'success' && response.data && !response.data.job_id) {
      this.updateLoadingFlag(loadingFlagKey, response);
      processData(response);
    } else {
      NotifyManager.error('Ошибка', 'Не удалось загрузить данные');
      this.jobLoadingFlags[loadingFlagKey] = false;
      this.clearJobInterval(instance);
    }
  }

  static updateLoadingFlag(loadingFlagKey, response) {
    this.jobResults[loadingFlagKey] = response;
    this.jobLoadingFlags[loadingFlagKey] = false;
  }

  static clearJobInterval(instance) {
    if (instance.jobIntervalId) {
      clearInterval(instance.jobIntervalId);
      instance.jobIntervalId = null;
    }
  }

  static resetJob(instance, controller, method, jobKey, clientId) {
    const jobIdKey = this.getJobKey(jobKey, clientId, 'id');
    const jobDateKey = this.getJobKey(jobKey, clientId, 'date');
    const loadingFlagKey = this.getLoadingFlagKey(controller, method, jobKey, clientId);

    // Очистка localStorage
    localStorage.removeItem(jobIdKey);
    localStorage.removeItem(jobDateKey);

    // Очистка флагов и кеша результатов
    delete this.jobLoadingFlags[loadingFlagKey];
    delete this.jobResults[loadingFlagKey];

    // Очищаем интервал у instance
    this.clearJobInterval(instance);
  }
}
